var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-0 ml-3 pb-0 mt-0 pt-0 mb-0 pb-0 mr-1"},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.weater_headers,"items":_vm.dailyWeather,"hide-default-header":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.icon",fn:function(ref){
var item = ref.item;
return [_c('v-img',{attrs:{"src":item.icon,"alt":"Sunny image","width":"40"}})]}},{key:"item.temp",fn:function(ref){
var item = ref.item;
return [_c('span',{domProps:{"innerHTML":_vm._s(item.temp)}}),_vm._v(" °C ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }